import { RoleType } from "@explorance/mly-types";
import { AnalysisContextState } from "context/AnalysisContext/state";
import { User } from "ts/user";

export const isDegraded = (user: User, analysisContextState: AnalysisContextState) =>
  user.roleType === RoleType.Viewer && !analysisContextState.analysisDetails.sharing;
